import { lazyNamed } from 'src/utils/lazyNamed.ts';

const BidReduction = {
  ModelDashboard: lazyNamed(() => import('./ModelDashboard/index.tsx'), 'ModelDashboard'),
  BidReductionConfigsList: lazyNamed(() => import('./BidReductionConfigsList/index.tsx'), 'BidReductionConfigsList'),
  BidReductionConfigForm: lazyNamed(() => import('./BidReductionConfigForm/index.tsx'), 'BidReductionConfigForm'),
};

export default BidReduction;
